module.exports = __webpack_public_path__ + "static/media/25542572_1703512906390560_5974069251825483266_o.962fb746.jpg";